export default __webpack_public_path__ + "static/media/loading-single.821bbea9.svg";